module.exports = __webpack_public_path__ + "static/img/45-1.a8c61a6.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/45-1.jpg
// module id = F6mf
// module chunks = 0